<template>
  <section id="home">
    <div id="home-banner">
      <img src="../../assets/img/home-banner.jpg" alt="" />
      <div id="hb-content">
        <h1>JC Steele Service Portal</h1>
        <div class="hb-subheading">
          Welcome to our service portal! We offer more than the industry’s best
          parts and service.
        </div>
        <router-link to="/Login" class="btn btn-dark" v-if="!currentUser"
          >Login</router-link
        >
        <router-link to="/Registration" class="btn btn-dark" v-if="!currentUser"
          >Request Account</router-link
        >
      </div>
    </div>
    <div id="home-tiles">
      <div class="container">
        <div class="row mb-5" v-show="this.success">
          <div class="col-12">
            <div class="tile black request-message">
              <ContentBlock
                :name="'REGISTRATION_REQUEST_MESSAGE'"
              ></ContentBlock>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 mb-4 mb-sm-0">
            <div class="tile red">
              <ContentBlock :name="'System_Message_1'"></ContentBlock>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="tile black">
              <ContentBlock :name="'System_Message_2'"></ContentBlock>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="home-content">
      <div class="container">
        <ContentBlock :name="'HOMEPAGE_CONTENT'"></ContentBlock>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
import { mapGetters } from "vuex";
export default {
  name: "index",
  computed: {
    ...mapGetters({ currentUser: "currentUser" }),
  },
  mounted() {
    delete localStorage.description;
    delete localStorage.searchTerm;
    if (this.$route.params.success) {
      this.success = true;
    }

    if (this.$route.matched[0].props.default.admin) {
      this.admin = true;
    }

    this.settingsDetails();

    Vue.filter("companyPhone", function(companyPhone) {
      return companyPhone
        .replace(/[^0-9]/g, "")
        .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
    });
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      success: false,
      admin: false,
      companyPhone: "",
    };
  },
  methods: {
    settingsDetails() {
      apiService
        .getCompanySettings()
        .then((request) => {
          this.settingsSuccessful(request);
        })
        .catch((err) => this.settingsFailed(err));
    },
    settingsSuccessful(request) {
      this.companyPhone = request.companyPhone;
    },
    settingsFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
  },
};
</script>
